import { AppBar, Grid, Link, makeStyles } from "@material-ui/core";
import { Link as RouterLink } from "react-router-dom";

const useStyles = makeStyles(theme => ({
    footer: {
        top: 'auto',
        bottom: 0,
        marginTop: theme.spacing(2)
    }
}))

let Footer = () => {
    const classes = useStyles();

    return (
        <AppBar position="fixed" color="inherit" elevation={0} className={classes.footer}>
            <Grid container alignContent="center">
                <Grid item xs />
                <Grid item>
                    <Link component={RouterLink} to="/site-terms/cookies-policy">Cookies policy</Link>&nbsp;|&nbsp;<Link href="https://www.videndummediasolutions.com/en/privacy-policy/" target="_blank">Privacy policy</Link>
                </Grid>
                <Grid item xs />
            </Grid>
        </AppBar>
    )
}

export default Footer;